import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200/60 transition-all duration-300"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          title={`${article.title} - 男性健康科普`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 text-xs font-medium bg-accent-500 text-background-50 dark:text-foreground-950 rounded-full whitespace-nowrap">
            {article.category}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 mb-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.publishDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime}
          </span>
        </div>
      </div>
    </Link>
  );
}